import { h } from "preact";

interface ProductLocationProps {
  location?: string | null;
}

/**
 * ProductLocation - Displays product location with icon
 * 
 * **Features:**
 * - Shows location pin icon with SVG
 * - Handles null/undefined location gracefully
 * - Uses semantic address tag for SEO
 * 
 * **Display:**
 * - Only renders if location is provided
 * - Icon and text aligned to top
 * - Gray text color for secondary information
 * 
 * @param location - Location string or null
 * @returns JSX element or null
 */
const ProductLocation = ({ location }: ProductLocationProps) => {
  if (!location) return null;

  return (
    <address className="flex items-center gap-2 md:gap-2.5 ">
      <div className="w-4 h-4 md:!w-5 md:!h-5 relative">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="auto"
          height="auto"
          viewBox="0 0 20 20"
          fill="none"
        >
          <g clip-path="url(#clip0_33415_6311)">
            <path
              d="M10 10.0001C10.5156 10.0001 10.957 9.82059 11.3242 9.46156C11.6914 9.10253 11.875 8.67093 11.875 8.16677C11.875 7.6626 11.6914 7.231 11.3242 6.87198C10.957 6.51295 10.5156 6.33343 10 6.33343C9.48438 6.33343 9.04297 6.51295 8.67578 6.87198C8.30859 7.231 8.125 7.6626 8.125 8.16677C8.125 8.67093 8.30859 9.10253 8.67578 9.46156C9.04297 9.82059 9.48438 10.0001 10 10.0001ZM10 16.7376C11.9062 15.0265 13.3203 13.472 14.2422 12.0741C15.1641 10.6761 15.625 9.43482 15.625 8.3501C15.625 6.68482 15.082 5.32128 13.9961 4.25948C12.9102 3.19767 11.5781 2.66677 10 2.66677C8.42188 2.66677 7.08984 3.19767 6.00391 4.25948C4.91797 5.32128 4.375 6.68482 4.375 8.3501C4.375 9.43482 4.83594 10.6761 5.75781 12.0741C6.67969 13.472 8.09375 15.0265 10 16.7376ZM10 19.1668C7.48438 17.0737 5.60547 15.1296 4.36328 13.3345C3.12109 11.5393 2.5 9.87788 2.5 8.3501C2.5 6.05843 3.25391 4.23274 4.76172 2.87302C6.26953 1.5133 8.01562 0.833435 10 0.833435C11.9844 0.833435 13.7305 1.5133 15.2383 2.87302C16.7461 4.23274 17.5 6.05843 17.5 8.3501C17.5 9.87788 16.8789 11.5393 15.6367 13.3345C14.3945 15.1296 12.5156 17.0737 10 19.1668Z"
              fill="#585468"
            />
          </g>
          <defs>
            <clipPath id="clip0_33415_6311">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <span className="text-neutral-100 text-xs md:text-sm font-medium font-inter-tight leading-[16px] md:leading-[18px] not-italic pt-[2px] md:pt-[1px]">
        {location}
      </span>
    </address>
  );
};

export default ProductLocation;
